import { Link as RRLink } from "react-router-dom";
import styled from "styled-components";
export const LinkStyled = styled(RRLink).attrs(() => ({
    name: "best-link",
})) `
  &&& {
    color: ${(props) => props.styles.color};
    font-size: ${(props) => props.styles.size};
    &:hover {
      cursor: pointer;
      color: ${(props) => props.styles.hover};
    }
    text-decoration: ${(props) => props.styles.textDecoration};
  }
`;
//# sourceMappingURL=LinkStyles.js.map